<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" offset-md="3">
        <form @submit.prevent="save">
          <DateSelector
            :date="form.date"
            @change="updateDate"
          />
          <FormErrors
            v-if="$v.form.$error && (!$v.form.date.required)"
          >
            <FormErrorsLine v-if="!$v.form.date.required" text="Polje je obvezno" />
          </FormErrors>

          <v-text-field
            v-model="form.label"
            label="Oznaka"
          ></v-text-field>
          <v-textarea
            v-model="form.comment"
            label="Komentar"
          >
          </v-textarea>
          <v-btn v-if="!skrij" type="submit" class="float-right">Shrani</v-btn>
          <!-- <v-btn v-if="!modalView && isNewAcceptanceForm" type="button" class="float-right mr-4" @click="saveAndRepeat">Shrani in dodaj novo</v-btn> -->
          <v-btn v-if="!skrij" text type="button" class="float-right mr-4" @click="cancel">Prekliči</v-btn>
          <div style="display: none;">
            {{spremenjenDatum}}
            {{spremenjenoOznakaOdpisa}}
            {{spremenjenKomentar}}
            {{spremenjenoKomentar}}
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
import FormErrors from '@/components/FormErrors'
import FormErrorsLine from '@/components/FormErrorsLine'
import DateSelector from './DateSelector.vue'

export default {
  components: {
    FormErrors,
    FormErrorsLine,
    DateSelector
  },
  props: {
    writeoffform: {
      default: () => {},
      type: Object
    },
    skrij: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localStaraForm: null,
      localClients: [],
      showAddClientModal: false,
      emptyForm: {
        date: moment().format('YYYY-MM-DD'),
        label: null,
        comment: null
      },
      form: {},
      dataFetched: false,
      razlog: null
    }
  },
  validations: {
    form: {
      date: {
        required
      }
    }
  },
  computed: {
    isNewAcceptanceForm () {
      return !this.writeoffform || Object.values(this.writeoffform).length === 0
    },
    spremenjenDatum () {
      return this.localStaraForm ? this.form.date !== this.localStaraForm.date : false
    },
    spremenjenoOznakaOdpisa () {
      return this.localStaraForm ? this.form.label !== this.localStaraForm.label : false
    },
    spremenjenKomentar () {
      return this.localStaraForm ? this.form.comment !== this.localStaraForm.comment : false
    }
  },
  methods: {
    save () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form })
      }
    },
    saveAndRepeat () {
      this.$v.$touch()
      if (!this.$v.form.$error) {
        this.$emit('save', { data: this.form, repeat: true })
      }
    },
    clearForm () {
      this.form = { ...this.emptyForm }
      this.$v.$reset()
    },
    cancel () {
      this.$emit('cancel')
    },
    updateDate ({ date }) {
      this.form.date = date
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.dataFetched = true
    })
  },
  created () {
    this.form = { ...this.emptyForm }
    console.log(this.isNewAcceptanceForm, this.writeoffform)
    if (!this.isNewAcceptanceForm) {
      this.form = { ...this.form, ...this.writeoffform }
    }
    this.localStaraForm = { ...this.form }
    this.localStaraForm.label = this.localStaraForm.label === null ? '' : this.localStaraForm.label
    this.localStaraForm.comment = this.localStaraForm.comment === null ? '' : this.localStaraForm.comment
  },
  watch: {
    spremenjenDatum (sprememba) {
      const razlog = 'spremenjenDatum'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenoOznakaOdpisa (sprememba) {
      const razlog = 'spremenjenStPrevzemnice'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    },
    spremenjenKomentar (sprememba) {
      const razlog = 'spremenjenDobavitelj'
      if ((this.dataFetched && this.razlog === razlog) || this.razlog === null) {
        this.razlog = razlog
        this.$emit('sprememba')
      }
    }
  }
}
</script>
